import { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { Box, CircularProgress, Typography } from '@mui/joy';
import { LayoutContext } from '../context';
import { APIConnectByToken } from '../api';

export default function ConnectDoctorPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { token, account } = useContext(LayoutContext);
  const [msg, setMsg] = useState('Подключаем вас к врачу…');
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const doctorToken = params.get('doctor') || '';
    if (!doctorToken) { navigate('/'); return; }

    const isPatient = !!token && Array.isArray(account?.type_profile) && account.type_profile.includes('patient');

    if (isPatient) {
      APIConnectByToken(doctorToken, token)
        .then((r) => { setMsg(r?.message || 'Готово'); navigate('/cabinet'); })
        .catch((e) => { setMsg(e?.response?.data?.error || 'Не удалось подключиться'); setTimeout(() => navigate('/cabinet'), 1500); });
    } else {
      // не авторизован — запоминаем токен и ведём на регистрацию/вход пациента
      localStorage.setItem('pendingDoctorToken', doctorToken);
      navigate(`/register/patient?doctor_token=${encodeURIComponent(doctorToken)}`);
    }
  }, [params, token, account, navigate]);

  return (
    <Box sx={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center', justifyContent: 'center' }}>
      <CircularProgress />
      <Typography level="body-md">{msg}</Typography>
    </Box>
  );
}